var _defs, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResCircBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1333.567,
    height: 682.092,
    viewBox: "0 0 1333.567 682.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.229,
    y1: 1.111,
    x2: 0.297,
    y2: -0.366,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0414ee",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08caf2"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 641.5,
    cy: 275.5,
    rx: 641.5,
    ry: 275.5,
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 0, 134.11)",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResCircBottom);
export default __webpack_public_path__ + "static/media/res-circ-bottom.d2bc7316a2a94527f2d920d48e26b579.svg";
export { ForwardRef as ReactComponent };